import WellBeingPartnerStatus from './WellBeingPartnerStatus'

export default WellBeingPartnerStatus
